import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white shadow-sm" }
const _hoisted_3 = {
  class: "card-header d-flex justify-content-between align-items-center py-4 px-4",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_4 = { class: "text-white fw-bold mb-1" }
const _hoisted_5 = { class: "text-white opacity-75" }
const _hoisted_6 = {
  key: 0,
  class: "badge fs-5 px-4 py-2 bg-warning text-dark"
}
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-30 letter-spacing" }
const _hoisted_8 = { class: "row g-4 mb-5" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "mb-0 fw-bold" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "mb-0 fw-bold" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "mb-0" }
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "mb-0" }
const _hoisted_17 = { class: "col-md-8" }
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = { class: "row g-4 mb-5" }
const _hoisted_20 = { class: "col-md-12" }
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-wrap gap-2 mt-2"
}
const _hoisted_22 = {
  key: 1,
  class: "mb-0 text-muted"
}
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "mb-0" }
const _hoisted_25 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "mb-0" }
const _hoisted_28 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_29 = { class: "row g-4 mb-5" }
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = { class: "mb-0" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "mb-0" }
const _hoisted_34 = { class: "row g-4" }
const _hoisted_35 = { class: "col-md-4" }
const _hoisted_36 = { class: "mb-0" }
const _hoisted_37 = { class: "col-md-4" }
const _hoisted_38 = { class: "mb-0" }
const _hoisted_39 = { class: "col-md-4" }
const _hoisted_40 = { class: "mb-0 text-muted small" }
const _hoisted_41 = { class: "d-flex justify-content-between mt-5 pt-4 border-top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_4, " Détail de la zone tarifaire – " + _toDisplayString(_ctx.tariffZone.name || 'Chargement...'), 1),
          _createElementVNode("small", _hoisted_5, " Code : " + _toDisplayString(_ctx.tariffZone.code) + " • Créée le " + _toDisplayString(_ctx.formatDate(_ctx.tariffZone.createdAt)), 1)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("span", {
            class: _normalizeClass(["badge fs-5 px-4 py-2 me-2", _ctx.tariffZone.isActive ? 'bg-success' : 'bg-secondary'])
          }, _toDisplayString(_ctx.tariffZone.isActive ? 'Active' : 'Inactive'), 3),
          (_ctx.tariffZone.isDefault)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, " Zone par défaut "))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "mb-4" }, [
          _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Informations générales")
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[0] || (_cache[0] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Code", -1)),
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.tariffZone.code || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[1] || (_cache[1] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Nom", -1)),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.tariffZone.name || '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_13, [
            _cache[2] || (_cache[2] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Statut", -1)),
            _createElementVNode("p", _hoisted_14, [
              _createElementVNode("span", {
                class: _normalizeClass(["badge", _ctx.tariffZone.isActive ? 'bg-success' : 'bg-secondary'])
              }, _toDisplayString(_ctx.tariffZone.isActive ? 'Active' : 'Inactive'), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Zone par défaut", -1)),
            _createElementVNode("p", _hoisted_16, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.tariffZone.isDefault ? 'fas fa-check text-success' : 'fas fa-times text-muted')
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(_ctx.tariffZone.isDefault ? 'Oui' : 'Non'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[4] || (_cache[4] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Description", -1)),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.tariffZone.description || '-'), 1)
          ])
        ]),
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "mb-4" }, [
          _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Portée géographique")
        ], -1)),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _cache[5] || (_cache[5] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Continent(s) d'origine du chargement", -1)),
            (_ctx.tariffZone.continent && _ctx.tariffZone.continent.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tariffZone.continent, (cont) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: cont,
                      class: "badge bg-info fs-6"
                    }, _toDisplayString(_ctx.getContinentLabel(cont)), 1))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_22, "Aucun continent spécifié")),
            _cache[6] || (_cache[6] = _createElementVNode("small", { class: "text-muted d-block mt-2" }, " Les continents pour lesquels cette zone tarifaire s'applique ", -1))
          ]),
          _createElementVNode("div", _hoisted_23, [
            _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Pays", -1)),
            _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.tariffZone.pays ? `${_ctx.tariffZone.pays.iso2_code} - ${_ctx.tariffZone.pays.name_fr}` : 'Tous les pays'), 1),
            (!_ctx.tariffZone.pays)
              ? (_openBlock(), _createElementBlock("small", _hoisted_25, "Aucune restriction (tous pays)"))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_26, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Port", -1)),
            _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.tariffZone.port ? `${_ctx.tariffZone.port.nomPort} (${_ctx.tariffZone.port.locode})` : 'Tous les ports'), 1),
            (!_ctx.tariffZone.port)
              ? (_openBlock(), _createElementBlock("small", _hoisted_28, "Aucune restriction (tous ports)"))
              : _createCommentVNode("", true)
          ])
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mb-4" }, [
          _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Période de validité")
        ], -1)),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Date de début", -1)),
            _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.tariffZone.effectiveFrom ? _ctx.formatDate(_ctx.tariffZone.effectiveFrom) : 'Immédiate'), 1)
          ]),
          _createElementVNode("div", _hoisted_32, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Date de fin", -1)),
            _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.tariffZone.effectiveTo ? _ctx.formatDate(_ctx.tariffZone.effectiveTo) : 'Aucune (illimitée)'), 1)
          ])
        ]),
        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "mb-4 mt-5" }, [
          _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Métadonnées")
        ], -1)),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Créée le", -1)),
            _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.formatDateTime(_ctx.tariffZone.createdAt)), 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Modifiée le", -1)),
            _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.tariffZone.updatedAt ? _ctx.formatDateTime(_ctx.tariffZone.updatedAt) : '-'), 1)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _cache[13] || (_cache[13] = _createElementVNode("label", { class: "text-black fw-semibold" }, "ID interne", -1)),
            _createElementVNode("p", _hoisted_40, _toDisplayString(_ctx.tariffZone.id), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_router_link, {
            to: "/listeTariffZone",
            class: "btn btn-secondary px-4"
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createElementVNode("i", { class: "fas fa-arrow-left me-2" }, null, -1),
              _createTextVNode(" Retour à la liste ", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              to: { name: 'EditTariffZonePage', params: { id: _ctx.tariffZone.id } },
              class: "btn btn-warning text-white px-4 me-2"
            }, {
              default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                _createElementVNode("i", { class: "flaticon-edit me-2" }, null, -1),
                _createTextVNode(" Modifier ", -1)
              ]))]),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ])
  ]))
}